import JobsSliderCard from "@components/cards/jobs-slider-card";
import SideArrow from "assets/svg/leftArrow.svg";
import Lines from "assets/svg/pages/jobs/lines.svg";
import Link from "next/link";
import React, { FC, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

type Props = {
  data: any;
  breakpoints?: any;
  title: string;
  hasLines?: boolean;
  textColor?: string;
  fillColor?: string;
};

const JobsCourses: FC<Props> = ({
  data,
  breakpoints = {
    300: {
      slidesPerView: 1,
      spaceBetween: 4,
    },
    375: {
      slidesPerView: 1.1,
      spaceBetween: 4,
    },
    767: {
      slidesPerView: 2,
      spaceBetween: 4,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 4,
    },
  },
  title,
  hasLines = true,
  textColor = "text-blue-550",
  fillColor = "fill-[#0577AF]",
}) => {
  const [slidePosition, setSlidePosition] = useState({
    isEnd: false,
    isBeginning: true,
  });

  const [swiperRef, setSwiperRef]: any = useState();
  useEffect(() => {
    if (data && data.length) {
      setSlidePosition({
        isEnd: isEnoughSlides(),
        isBeginning: true,
      });
    }
  }, [data]);
  useEffect(() => {
    function updateSize() {
      if (data && data.length) {
        setSlidePosition({
          isEnd: isEnoughSlides(),
          isBeginning: true,
        });
      }
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  const isEnoughSlides = () => {
    const windowWidth = window.innerWidth;
    switch (true) {
      case windowWidth > 1024: {
        return !(data.length > 4);
      }
      case windowWidth > 767: {
        return !(data.length > 2);
      }
      case windowWidth > 375: {
        return !(data.length > 1);
      }
      default: {
        return false;
      }
    }
  };
  return (
    <div className="z-10 flex w-full flex-col">
      <div className="mb-6 flex w-full justify-between">
        <div className="">
          <h3 className={`relative text-lg font-bold md:text-xl ${textColor}`}>
            {title}
            {hasLines ? <Lines className="absolute left-0" /> : undefined}
          </h3>
        </div>
        <div className={`hidden grid-cols-3 items-center gap-x-5 md:grid ${textColor}`}>
          <Link href={"/search"}>
            <a>
              <span className="cursor-pointer">همه</span>
            </a>
          </Link>
          <SideArrow
            className={`rotate-180 cursor-pointer ${
              slidePosition?.isBeginning ? "fill-slate-300" : fillColor
            }`}
            onClick={() => swiperRef?.slidePrev()}
          />
          <SideArrow
            className={`cursor-pointer ${
              slidePosition?.isEnd ? "fill-slate-300" : fillColor
            }`}
            onClick={() => swiperRef?.slideNext()}
          />
        </div>
      </div>
      <div className="relative -mx-2 h-auto">
        <Swiper
          onSlideChange={(e) =>
            setSlidePosition({ isBeginning: e.isBeginning, isEnd: e.isEnd })
          }
          onSwiper={(e) => {
            setSwiperRef(e);
          }}
          breakpoints={breakpoints}
        >
          {data?.map((item: any, index: number) => (
            <SwiperSlide key={item?.id?.toString()}>
              <JobsSliderCard item={item} index={index} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default JobsCourses;
